
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"listGeozoneFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"favourite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"muted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"propertyFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"objectsToObjectsByObject1Id"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object2"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"application","block":false},{"kind":"StringValue","value":"monitor","block":false},{"kind":"StringValue","value":"geotag","block":false}]}}]}}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"object2"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"load"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schema"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"application","block":false},{"kind":"StringValue","value":"monitor","block":false},{"kind":"StringValue","value":"geozone","block":false}]}}]}}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"listGeozoneFields"},"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"listenGeozoneList"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Objects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterA"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tags"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"application","block":false},{"kind":"StringValue","value":"monitor","block":false},{"kind":"StringValue","value":"geozone","block":false}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"listGeozoneFields"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectProperty"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectId"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"propertyFields"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":866}};
    doc.loc.source = {"body":"#import '@/modules/common/api/object-property.fragment.graphql'\n\nfragment listGeozoneFields on Object {\n  id\n  name\n  enabled\n  favourite\n  muted\n  objectProperties {\n    ...propertyFields\n  }\n  objectsToObjectsByObject1Id(\n    filter: {\n      object2: {\n        schemaTags: { contains: [\"application\", \"monitor\", \"geotag\"] }\n      }\n    }\n  ) {\n    id\n    object2 {\n      id\n    }\n  }\n}\n\nquery load {\n  objects(\n    filter: {\n      schema: { mTags: { contains: [\"application\", \"monitor\", \"geozone\"] } }\n    }\n  ) {\n    ...listGeozoneFields\n  }\n}\n\nsubscription listenGeozoneList {\n  Objects(filterA: { tags: [\"application\", \"monitor\", \"geozone\"] }) {\n    event\n    relatedNodeId\n    relatedNode {\n      __typename\n      ... on Object {\n        ...listGeozoneFields\n      }\n      ... on ObjectProperty {\n        objectId\n        ...propertyFields\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('@/modules/common/api/object-property.fragment.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["listGeozoneFields"] = oneQuery(doc, "listGeozoneFields");
        
        module.exports["load"] = oneQuery(doc, "load");
        
        module.exports["listenGeozoneList"] = oneQuery(doc, "listenGeozoneList");
        
